<template>
  <section>
    <div class="container">
      <div class="handle-box">
        <router-link :to="{ path: '/contacts/add', query: { id: 0 } }">
          <el-button type="primary" size="small" icon="el-icon-plus"
            >添加</el-button
          >
        </router-link>
      </div>
      <el-table
        :data="tableData"
        stripe
        @selection-change="checkIds"
        v-loading="loading"
        ref="multipleTable"
      >
        <el-table-column type="selection" width="65" align="right"></el-table-column>
        <el-table-column prop="cid" label="ID" align="center" v-if="false"></el-table-column>
        <el-table-column prop="uid" label="ID" align="center" v-if="false"></el-table-column>
        <el-table-column prop="wid" label="ID" align="center" v-if="false"></el-table-column>
        <el-table-column prop="" label="所属用户" align="center">
          <div slot-scope="scope">{{scope.row.user_name}}[{{scope.row.role_name}}]</div>
        </el-table-column>
        <el-table-column prop="contact_name" label="联系人" align="center"></el-table-column>
        <el-table-column prop="contact_mobile" label="手机号码" align="center"></el-table-column>
        <!-- <el-table-column prop="contact_tel" label="固定电话" align="center"></el-table-column> -->
        <!-- <el-table-column prop="" label="关联微信" align="center">
          <div slot-scope="scope">
            <span v-if="scope.row.wid">已关联</span>
            <span v-else>未关联</span>
          </div>
        </el-table-column> -->
        <!-- <el-table-column prop="wx_name" label="微信昵称" align="center"></el-table-column>
        <el-table-column prop="wx_mobile" label="微信手机号" align="center"></el-table-column> -->
        <el-table-column label="操作" align="center">
          <div slot-scope="scope">
            <!-- <el-button class="ml10" type="text" icon="el-icon-link" v-if="!scope.row.wid" @click="openWXDialog()">绑定微信</el-button> -->
            <router-link :to="{ path: '/contacts/update', query: { id: scope.row.cid } }">
              <el-button class="ml10" type="text" icon="el-icon-edit">修改</el-button>
            </router-link>
            <el-button type="text" icon="el-icon-delete" class="red ml10" @click="del('Contacts/Delete', scope.row.cid)">
            删除</el-button>
          </div>
        </el-table-column>
      </el-table>
      <!-- 表格底部 -->
      <div class="cms-list-footer">
        <div class="cms-left">
          <el-button
          size="small"
            :disabled="disabled"
            @click="deleteBatch('Contacts/Delete', ids)"
            >批量删除</el-button
          >
        </div>
        <!-- 分页组件 -->
        <cms-pagination :total="total" @change="getPages"></cms-pagination>
      </div>
      <!-- 微信绑定 -->
      <!-- <el-dialog title="关联微信" :visible.sync="wxDialog" width="50%" @opened="openCallback()">
        <cmsBindWX :uid="dataInfo.uid" :mobile="dataInfo.user_mobile" @close="wxDialog=false"></cmsBindWX>
      </el-dialog> -->
    </div>
  </section>
</template>

<script>
import listMixins from "@/mixins/list";

export default {
  name: "Contacts",
  mixins: [listMixins],
  data() {
    return {
      params: {
        //只需要业务参数
        user: "",
        pageNo: "1",
        pageSize: "10"
      },
      roles: [],
    };
  },
  mounted() {},
  methods: {
    checkIds(val) {
      let ids = [];
      for (let i in val) {
        ids.push(val[i].cid);
      }
      this.ids = ids.join(",");
      this.disabled = val.length > 0 ? false : true;
      this.checkedList = val;
    },
    del(val1, val2) {
      this.deleteBatch(val1, val2);
    }
  },
  created() {
    //获取用户信息
    this.params.uid = this.$store.state.userInfo.id;
    this.initTableData("Contacts/PagedView", this.params);
  },
  watch: {
    // 修复增改之后，重新加载页面，无法执行 created  函数
    $route(to,from){
      this.params.uid = this.$store.state.userInfo.id;
      this.initTableData("Contacts/PagedView", this.params);
    }
  }
};
</script>
